<template>
    <div class="kitchenWap">
        <div class="livingRoomSpace">
            <div class="jianbianq"  :class="{'jianbianh':isbrandConcepttitle}" ref="brandConcepttitle">
            <div class="founder spaceCustomization">
                <div class="yishu marginTX"></div>
                <div class="beijing">衣帽空间</div>
                <p v-html="seriesIntroduce.cloakroomSpace"  class="kjjianjie"></p>       
                <!-- <div class="moreBut">了解更多</div> -->
            </div>
        </div>

        <!-- 调整顺序：轻奢衣帽间放到第1位 -->
        <div class="jianbianq"  :class="{'jianbianh':isLightLuxuryClosetMx}" ref="lightLuxuryClosetMx">
            <div class="spaceCustomization_img homeDecoration lightLuxuryCloset" ref="lightLuxuryCloset" @mouseenter="lightLuxuryClosetEnter" @mouseleave="lightLuxuryClosetLeave">
                <img :src="'https://www.vifa.cn' + lightLuxuryClosetImage" alt="" v-if="lightLuxuryClosetImage">
                <img src="@/common/image/ymkjbanner1.png" alt="" v-else>
                <div class="dingwei" :class="{'dingweishow':isLightLuxuryClosetDingwei}">
                    <div class="dingweia" @click="lightLuxuryClosetDingweia">+</div>
                    <div class="dingweib" @click="lightLuxuryClosetDingweib">+</div>
                    <div class="dingweic" @click="lightLuxuryClosetDingweic">+</div>
                </div>
                <div class="dwzhankai" v-show="isLightLuxuryClosetDwzhankai == index" v-for="(item,index) in lightLuxuryClosetData" :key='index' @click="lightLuxuryClosetDwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">轻奢衣帽间</div>
            <router-link :to="{path:'/productDtails',query:{title:'轻奢衣帽间',SpaceActiv:4}}"><div class="moreBut">了解更多</div></router-link>
        </div>
        <div class="jianbianq"  :class="{'jianbianh':iskjmx}" ref="kjmx">


          <div class="jianbianq"  :class="{'jianbianh':isyimaokjj}" ref="yimaokjj">
            <div class="spaceCustomization_img homeDecoration fcscfaa" ref="homeDecoration" @mouseenter="fcscftenteraa" @mouseleave="fcscftleaveaa">
              <img :src="'https://www.vifa.cn' + ymkjbanner5image" alt="" />
              <div class="dingwei" :class="{'dingweishow':isfcscftdingweiaa}">

                <div class="dingweia" @click="fcscftdingweiaaa">+</div>

                <div class="dingweid" @click="fcscftdingweidaa">+</div>

              </div>
              <transition-group name="tran">
                <div class="dwzhankai" v-show="isfcscftdwzhankaiaa == index" v-for="(item,index) in fcscftdwzhankaiDataaa" :key='index' @click="fcscftdwguanbiaa">
                  <ul>
                    <li>
                      <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                      <div>{{item.title}}</div>
                      <p>{{item.introduce}}</p>
                    </li>
                  </ul>
                </div>
              </transition-group>
            </div>
            <div class="hscttitle">步入式衣帽间</div>
            <router-link :to="{path:'/productDtails',query:{title:'步入式衣帽间',SpaceActiv:4,ittitle:'Armadio indipendente III',entitle:'Independent cloakroom III'}}"><div class="moreBut">了解更多</div></router-link>
          </div>

            
            <div class="spaceCustomization_img homeDecoration cfct" ref="homeDecoration" @mouseenter="cfctenter" @mouseleave="cfctleave">
                <img src="@/common/image/ymkjbanner2.png" alt="">
                <div class="dingwei" :class="{'dingweishow':iscfctdingwei}">
                    <div class="dingweia" @click="cfctdingweia">+</div>
                    <div class="dingweib" @click="cfctdingweib">+</div>
                    <div class="dingweic" @click="cfctdingweic">+</div>
                    <div class="dingweid" @click="cfctdingweid">+</div>
                </div>
                <div class="dwzhankai" v-show="iscfctdwzhankai == index" v-for="(item,index) in cfctdwzhankaiData" :key='index' @click="cfctdwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">隔断式衣帽间</div>
            <router-link :to="{path:'/productDtails',query:{title:'隔断式衣帽间',SpaceActiv:4,ittitle:'Armadio divisorio',entitle:'Partitioned cloakroom'}}"><div class="moreBut">了解更多</div></router-link>
        </div>
        <div class="jianbianq"  :class="{'jianbianh':issjmx}" ref="sjmx">
            <div class="spaceCustomization_img homeDecoration hsct" ref="homeDecoration" @mouseenter="homeDM" @mouseleave="homeDMout">
                <img src="@/common/image/ymkjbanner1.png" alt="">
                <div class="dingwei" :class="{'dingweishow':isdingwei}">
                    <div class="dingweia" @click="hsctdingweia">+</div>
                    <div class="dingweib" @click="hsctdingweib">+</div>
                    <div class="dingweic" @click="hsctdingweic">+</div>
                    <div class="dingweid" @click="hsctdingweid">+</div>
                    <!-- <div class="dingweie" @click="hsctdingweie">+</div>
                    <div class="dingweif" @click="hsctdingweif">+</div> -->
                    <!-- <div class="dingweig" @click="hsctdingweig">+</div> -->
                </div>
                <div class="dwzhankai" v-show="isdwzhankai == index" v-for="(item,index) in dwzhankaiData" :key='index' @click="dwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">独立衣帽间Ⅰ</div>
            <router-link :to="{path:'/productDtails',query:{title:'独立衣帽间Ⅰ',SpaceActiv:4,ittitle:'Armadio indipendente I',entitle:'Independent cloakroom I'}}"><div class="moreBut">了解更多</div></router-link>
        </div>
    
        <div class="jianbianq"  :class="{'jianbianh':isshmx}" ref="shmx">
            
            <div class="spaceCustomization_img homeDecoration fcscf" ref="homeDecoration" @mouseenter="fcscftenter" @mouseleave="fcscftleave">
                <img src="@/common/image/ymkjbanner3.png" alt="">
                <div class="dingwei" :class="{'dingweishow':isfcscftdingwei}">
                    <div class="dingweia" @click="fcscftdingweia">+</div>
                    <div class="dingweib" @click="fcscftdingweib">+</div>
                </div>
                <div class="dwzhankai" v-show="isfcscftdwzhankai == index" v-for="(item,index) in fcscftdwzhankaiData" :key='index' @click="fcscftdwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">独立衣帽间Ⅱ</div>
            <router-link :to="{path:'/productDtails',query:{title:'独立衣帽间Ⅱ',SpaceActiv:4,ittitle:'Armadio indipendente II',entitle:'Independent cloakroom II'}}"><div class="moreBut">了解更多</div></router-link>
        </div>


        <div class="jianbianq"  :class="{'jianbianh':isyimaokj}" ref="yimaokj">
            <div class="spaceCustomization_img homeDecoration fcscfa" ref="homeDecoration" @mouseenter="fcscftentera" @mouseleave="fcscftleavea">
                <img src="@/common/image/ymkjbanner4.png" alt="">
                <div class="dingwei" :class="{'dingweishow':isfcscftdingweia}">
                    <div class="dingweia" @click="fcscftdingweiaa">+</div>
                    <div class="dingweib" @click="fcscftdingweiba">+</div>
                    <div class="dingweic" @click="fcscftdingweica">+</div>
                </div>
                <transition-group name="tran">
                <div class="dwzhankai" v-show="isfcscftdwzhankaia == index" v-for="(item,index) in fcscftdwzhankaiDataa" :key='index' @click="fcscftdwguanbia">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
                </transition-group>
            </div>
            <div class="hscttitle">独立衣帽间Ⅲ</div>
            <router-link :to="{path:'/productDtails',query:{title:'独立衣帽间Ⅲ',SpaceActiv:4,ittitle:'Armadio indipendente III',entitle:'Independent cloakroom III'}}"><div class="moreBut">了解更多</div></router-link>
        </div>

        </div>
    </div>
</template>

<script>
import { getProductDetails } from "@/api/api";


export default {
  name: 'clothesAndHatsSpace',
  data(){
      return{
        dwzhankaiData:[],
        isdwzhankai:999,
        isdingwei:false,
        cfctdwzhankaiData:[],
        iscfctdwzhankai:999,
        iscfctdingwei:false,
        fcscftdwzhankaiData:[],
        isfcscftdwzhankai:999,
        isfcscftdingwei:false,

        fcscftdwzhankaiDataa:[],
        isfcscftdwzhankaia:999,
        isfcscftdingweia:false,

        fcscftdwzhankaiDataaa:[],
        isfcscftdwzhankaiaa:999,
        isfcscftdingweiaa:false,
        ymkjbanner5image:null,

        // 新增第6个产品区域（轻奢衣帽间）
        lightLuxuryClosetData:[],
        isLightLuxuryClosetDwzhankai:999,
        isLightLuxuryClosetDingwei:false,
        lightLuxuryClosetImage:null,

        isbrandConcepttitle:false,
        issjmx:false,
        iskjmx:false,
        isshmx:false,
        isyimaokj:false,
        isyimaokjj:false,
        isLightLuxuryClosetMx:false,
      }
  },
    components: {
    },
    props:{
        seriesIntroduce: {
        type: String 
        }
    },
    mounted() {
       window.addEventListener("scroll", this.handleScroll);    
       this.isbrandConcepttitle = true    
       this.issjmx = true
       this.getkalajinyanData()
       this.getcfctdwzhankaiData()
       this.getfcscftdwzhankaiData()
       this.getfcscftdwzhankaiDataa()
       this.getfcscftdwzhankaiDataaa()
       this.getLightLuxuryClosetData()
    },
    methods:{
        getkalajinyanData(){
            let data = {
                productName:"独立衣帽间Ⅰ"
            }
            getProductDetails(data)
            .then(res =>{
                this.dwzhankaiData = res.productSpecific
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getcfctdwzhankaiData(){
            let data = {
                productName:"隔断式衣帽间"
            }
            getProductDetails(data)
            .then(res =>{
                this.cfctdwzhankaiData = res.productSpecific
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getfcscftdwzhankaiData(){
            let data = {
                productName:"独立衣帽间Ⅱ"
            }
            getProductDetails(data)
            .then(res =>{
                this.fcscftdwzhankaiData = res.productSpecific
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getfcscftdwzhankaiDataa(){
            let data = {
                productName:"独立衣帽间Ⅲ"
            }
            getProductDetails(data)
            .then(res =>{
                this.fcscftdwzhankaiDataa = res.productSpecific
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getfcscftdwzhankaiDataaa(){
            let data = {
                productName:"步入式衣帽间"
            }
            getProductDetails(data)
            .then(res =>{
                this.fcscftdwzhankaiDataaa = res.productSpecific;
                this.ymkjbanner5image=res.productSeries.image
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getLightLuxuryClosetData(){
            let data = {
                productName:"轻奢衣帽间"
            }
            getProductDetails(data)
            .then(res =>{
                this.lightLuxuryClosetData = res.productSpecific
                this.lightLuxuryClosetImage = res.productSeries.image
            })
            .catch(res=>{
                console.log(res)
            })
        },
        handleScroll(){
           this.$nextTick(()=>{
            this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
            // if (e.deltaY>0) {
                if (this.$refs.brandConcepttitle.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitle = false
                }
                if (this.$refs.sjmx.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.issjmx = false
                }
                if (this.$refs.brandConcepttitle.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitle = true
                }
                if (this.$refs.sjmx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.issjmx = true
                }
                if (this.$refs.kjmx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.iskjmx = true
                }
                if (this.$refs.shmx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isshmx = true
                }
                if (this.$refs.yimaokj.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isyimaokj = true
                }

            if (this.$refs.yimaokjj.offsetTop < this.scroll +document.documentElement.clientHeight) {
                this.isyimaokjj = true
            }

            if (this.$refs.lightLuxuryClosetMx && this.$refs.lightLuxuryClosetMx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                this.isLightLuxuryClosetMx = true
            }

            // }else if (e.deltaY < 0) {
                if (this.$refs.brandConcepttitle.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isbrandConcepttitle = false
                }
                if (this.$refs.sjmx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.issjmx = false
                }
                if (this.$refs.kjmx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.iskjmx = false
                }
                if (this.$refs.shmx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isshmx = false
                }
                if (this.$refs.yimaokj.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isyimaokj = false
                }
                if (this.$refs.lightLuxuryClosetMx && this.$refs.lightLuxuryClosetMx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isLightLuxuryClosetMx = false
                }
           })
            // }
        },
        homeDM(){
            this.isdingwei = true
        },
        homeDMout(){
            this.isdingwei = false
        },
        dwguanbi(){
            this.isdwzhankai = 999
        },
        hsctdingweia(){
            this.isdwzhankai = 0
        },
        hsctdingweib(){
            this.isdwzhankai = 1
        },
        hsctdingweic(){
            this.isdwzhankai = 2
        },
        hsctdingweid(){
            this.isdwzhankai = 3
        },
        hsctdingweie(){
            this.isdwzhankai = 4
        },
        hsctdingweif(){
            this.isdwzhankai = 5
        },
        // hsctdingweig(){
        //     this.isdwzhankai = 6
        // },
        cfctenter(){
            this.iscfctdingwei = true
        },
        cfctleave(){
            this.iscfctdingwei = false
        },
        cfctdwguanbi(){
            this.iscfctdwzhankai = 999
        },
        cfctdingweia(){
            this.iscfctdwzhankai = 0
        },
        cfctdingweib(){
            this.iscfctdwzhankai = 1
        },
        cfctdingweic(){
            this.iscfctdwzhankai = 2
        },
        cfctdingweid(){
            this.iscfctdwzhankai = 3
        },
        fcscftenter(){
            this.isfcscftdingwei = true
        },
        fcscftleave(){
            this.isfcscftdingwei = false
        },
        fcscftdwguanbi(){
            this.isfcscftdwzhankai = 999
        },
        fcscftdingweia(){
            this.isfcscftdwzhankai = 0
        },
        fcscftdingweib(){
            this.isfcscftdwzhankai = 1
        },
        fcscftentera(){
            this.isfcscftdingweia = true
        },
        fcscftleavea(){
            this.isfcscftdingweia = false
        },
        fcscftdwguanbia(){
            this.isfcscftdwzhankaia = 999
        },


        fcscftdingweiaa(){
            this.isfcscftdwzhankaia = 0
        },
        fcscftdingweiba(){
            this.isfcscftdwzhankaia = 1
        },
        fcscftdingweica(){
            this.isfcscftdwzhankaia = 2
        },

        fcscftdingweiaaa(){
            this.isfcscftdwzhankaiaa = 0
        },
        fcscftdingweibaa(){
            this.isfcscftdwzhankaiaa = 1
        },
        fcscftdingweicaa(){
          this.isfcscftdwzhankaiaa = 2
        },
        fcscftdingweidaa(){
          this.isfcscftdwzhankaiaa = 3
        },
        fcscftdingweieaa(){
          this.isfcscftdwzhankaiaa = 4
        },
        fcscftdingweigaa(){
          this.isfcscftdwzhankaiaa = 5
        },

        fcscftenteraa(){
            this.isfcscftdingweiaa = true
        },
        fcscftleaveaa(){
            this.isfcscftdingweiaa = false
        },
        fcscftdwguanbiaa(){
            this.isfcscftdwzhankaiaa = 999
        },

        // 轻奢衣帽间的方法
        lightLuxuryClosetEnter(){
            this.isLightLuxuryClosetDingwei = true
        },
        lightLuxuryClosetLeave(){
            this.isLightLuxuryClosetDingwei = false
        },
        lightLuxuryClosetDwguanbi(){
            this.isLightLuxuryClosetDwzhankai = 999
        },
        lightLuxuryClosetDingweia(){
            this.isLightLuxuryClosetDwzhankai = 0
        },
        lightLuxuryClosetDingweib(){
            this.isLightLuxuryClosetDwzhankai = 1
        },
        lightLuxuryClosetDingweic(){
            this.isLightLuxuryClosetDwzhankai = 2
        },

    },
  unmounted(){
      window.removeEventListener("scroll",this.handleScroll)  
    }
}
</script>

<style scoped>
.kitchenWap .spaceCustomization p{
    /* width: 740px; */
    margin: 0 auto;white-space: pre-wrap;
    /* text-align: left; */
}
.hsct .dingwei .dingweia{
    left: 15.5%;
    top: 49.5%;
}
.hsct .dingwei .dingweib{
    left: 31.5%;
    top: 33%;
}
.hsct .dingwei .dingweic{
    left: 46%;
    top: 37%;
}
.hsct .dingwei .dingweid{
    left: 62%;
    top: 67%;
}
/* .hsct .dingwei .dingweie{
    left: 40%;
    top: 49%;
}
.hsct .dingwei .dingweif{
    left: 9%;
    top: 22%;
}
.hsct .dingwei .dingweig{
    left: 64.5%;
    top: 36%;
} */
.kitchenWap .dwzhankai ul{
    width: 875px;
    height: 710px;
}
.kitchenWap .dwzhankai ul li .cfimg{
    width: 400px;
    height: 352.5px;
    margin:88px 0 25px 355px;
}
.kitchenWap .dwzhankai ul li div{
    font-size: 30px;
    padding-top: 0;
}
.kitchenWap .dwzhankai ul li p{
    padding-top: 15px;
    font-size: 16px;
}
.hscttitle{
    font-size: 30px;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 60px;
}
.cfct .dingwei .dingweia{
    left: 16%;
    top: 14%;
}
.cfct .dingwei .dingweib{
    left: 27.5%;
    top: 49%;
}
.cfct .dingwei .dingweic{
    left: 39%;
    top: 52%;
}
.cfct .dingwei .dingweid{
    left: 55%;
    top: 45%;
}
.cfct .dingwei .dingweie{
    left: 63.5%;
    top: 30%;
}
.fcscf .dingwei .dingweia{
    left: 17.5%;
    top: 16%;
}
.fcscf .dingwei .dingweib{
    left: 49%;
    top: 44%;
}
.fcscfa .dingwei .dingweia{
        left: 28%;
    top: 47%;
}
.fcscfa .dingwei .dingweib{
        left: 62%;
    top: 43%;
}
.fcscfa .dingwei .dingweic{ 
left: 81%;
    top: 67%;
}
.fcscfa .dingwei .dingweid{
    left: 68%;
    top: 67%;
}

.fcscfaa .dingwei .dingweia{
    left: 13%;
    top: 40%;
}
.fcscfaa .dingwei .dingweib{
    left: 19%;
    top: 57%;
}
.fcscfaa .dingwei .dingweic{
    left: 24%;
    top: 62%;
}
.fcscfaa .dingwei .dingweid{
    left: 53%;
    top: 53%;
}.fcscfaa .dingwei .dingweie{
    left: 70%;
    top: 57%;
}
.fcscfaa .dingwei .dingweig{
    left: 29%;
    top: 50%;
}

/* 轻奢衣帽间的+号位置（从左到右排列） */
.lightLuxuryCloset .dingwei .dingweia{
    left: 75%;
    top: 35%;
}
.lightLuxuryCloset .dingwei .dingweib{
    left: 50%;
    top: 62%;
}
.lightLuxuryCloset .dingwei .dingweic{
    left: 38%;
    top: 31%;
}

</style>
